export default __webpack_public_path__ + "static/media/area-arrow.2cf7bf95.svg";